export default __webpack_public_path__ + "static/media/NEW-INVESTA-SIMPLE-BORDER.9b2b68f1.png";